var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.8513 19.9432C40.8513 8.92889 31.9251 0 20.9139 0C9.90284 0 0.976562 8.92889 0.976562 19.9432C0.976562 30.9576 9.90284 39.8865 20.9139 39.8865C31.9251 39.8865 40.8513 30.9576 40.8513 19.9432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4681 15.8107C33.3111 14.2958 32.9735 12.6211 31.7309 11.741C30.7684 11.0585 29.5033 11.0333 28.3223 11.0347C25.8257 11.0347 23.3278 11.0389 20.8312 11.0403C18.4299 11.0431 16.0286 11.0445 13.6274 11.0473C12.6242 11.0473 11.6492 10.9703 10.7175 11.4047C9.91755 11.7775 9.29131 12.4866 8.91445 13.2756C8.39188 14.3728 8.28261 15.6159 8.21956 16.8295C8.10328 19.0395 8.11589 21.2551 8.25459 23.4637C8.35686 25.0753 8.61604 26.8565 9.86151 27.8837C10.9655 28.7932 12.5234 28.838 13.9552 28.8394C18.5 28.8436 23.0462 28.8478 27.5923 28.8506C28.1752 28.852 28.7832 28.8408 29.3772 28.7764C30.5456 28.6502 31.6594 28.3153 32.4103 27.4492C33.1682 26.5762 33.363 25.3612 33.4779 24.2106C33.7581 21.4191 33.7553 18.6008 33.4681 15.8107ZM18.203 23.8561V16.0293L24.9781 19.942L18.203 23.8561Z",
    fill: "#043873"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube_icon.9792d3bd9f82ef130ac126ccf1569e35.svg";
export { ForwardRef as ReactComponent };